import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { AutoComplete } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';
import { SearchResult, SearchResultType } from '@/shared/types/search';

import { refreshGrids } from '@/front/grid';
import { showOffcanvas } from '@/front/offcanvas';

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('search-button')?.addEventListener('click', () => document.getElementById('search')?.focus());

  const search: AutoComplete = new AutoComplete({
    dataSource: new DataManager({
      url: routes.data.search(),
      adaptor: new UrlAdaptor(),
    }),
    fields: {
      groupBy: 'type',
      value: 'name',
    },
    groupTemplate: '<div class="search-result-group">${window.formatters.formatSearchResultType(type)}</div>',
    itemTemplate: '<div class="search-result-item">${window.formatters.formatSearchResultName(name)}</div>',
    allowCustom: false,
    // autofill: true,
    showClearButton: true,
    suggestionCount: 100,
    placeholder: 'Search clients and tasks',
    width: 600,
    popupHeight: 600,
    change: () => {
      const result = search.getDataByValue(search.value as string) as SearchResult;

      let url: string | undefined;

      if (result.type === 'organisation') {
        url = routes.organisations.edit({ id: result.id });
      } else if (result.type === 'individual') {
        url = routes.individuals.edit({ id: result.id });
      } else if (result.type === 'task') {
        url = routes.tasks.edit({ id: result.id });
      }

      if (url) {
        showOffcanvas({
          url,
          onHide: refreshGrids,
        });
      }

      search.clear();
    },
  });

  search.appendTo('#search');
});

export const formatSearchResultType = (type: SearchResultType) => {
  if (type === 'organisation') {
    return 'Organisations';
  } else if (type === 'individual') {
    return 'Individuals';
  } else if (type === 'task') {
    return 'Tasks';
  }

  return '';
};

export const formatSearchResultName = (name: string) =>
  name
    .split('|')
    .map((part) => part.trim())
    .filter((part) => part)
    .map((part) => `<span>${part}</span>`)
    .join('');
